import React from 'react'
import { Button } from '@mui/material'
import { useTranslation } from "react-i18next";

import Navbar from './Navbar'

function ContactUs() {
  const { t } = useTranslation();
  
  return (
    <>
      <Navbar header={t("signedOutUser.navbar.linkButtons_contactUs")}/>
      <div className="mainContent">
        <div style={{display: "flex", alignItems: "center", justifyContent:"center", width: "100%"}}>
          <div className="contactUs">
            <h3>{t("signedOutUser.contactUs.title")}: </h3>
            <p><b>{t("signedOutUser.contactUs.addressLabel")} </b>{t("signedOutUser.contactUs.addressLine1")}<br/>
              {t("signedOutUser.contactUs.addressLine2")}<br/>
              {t("signedOutUser.contactUs.addressLine3")}<br/>
              {t("signedOutUser.contactUs.addressLine4")}<br/>
              {t("signedOutUser.contactUs.addressLine5")}
            </p>
            {/* <h4>Phone: <span></span>
              <Button 
                variant="text" 
                href="tel:+91-022-25767695"
                sx={{padding: "0", textTransform: "lowercase", textDecoration: "underline", textUnderlinePosition: "under"}} 
              >+91-022-25767695</Button>
            </h4> */}
            <h4>{t("signedOutUser.contactUs.emailLabel")} <span></span>
              <Button 
                variant="text" 
                href="mailto:prosical.iitb@gmail.com"
                sx={{padding: "0", textTransform: "lowercase", textDecoration: "underline", textUnderlinePosition: "under"}} 
              >prosical.iitb[AT]gmail.com</Button>
            </h4>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs